import React, { ReactNode, useEffect, useState } from 'react'
import Scorecards from './Scorecards';
import AutomatedQA from './AutomatedQA';
import { Drawer, DrawerContent, DrawerItem, DrawerItemProps, DrawerSelectEvent } from '@progress/kendo-react-layout';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { Button } from '@progress/kendo-react-buttons';

interface INavItem {
  text?: string;
  icon?: string;
  selected?: boolean;
  content?: ReactNode;
  key?: string;
}

const items: INavItem[] = [
  {
    text: "Evaluation Scorecard",
    icon: "bi bi-person",
    selected: false,
    content: <Scorecards />,
    key: "UsersTitle",
  },
  {
    text: "Automated QA  ",
    icon: "bi bi-shield-check",
    selected: true,
    content: <AutomatedQA />,
    key: "PermissionGroupsTitle",
  },
];

function ScorecardManagement() {

  const [expanded, setExpanded] = useState<boolean>(true);
  const [navItems, setNavItems] = useState<INavItem[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    setNavItems(getTabItems());
  }, []);

  const getTabItems = () => {
    var _navItem = items
      .filter((item) => {
        return true;
      })
      .map((item, index) => {
        return {
          ...item,
          selected: index === selectedId,
        };
      });

    return _navItem;
  };

  const handleExpandChange = () => {
    setExpanded((prevState) => !prevState);
  };

  const handleSelectionChange = (event: DrawerSelectEvent) => {
    navItems.forEach((i, idx) => {
      if (idx === event.itemIndex) {
        i.selected = true;
      } else {
        i.selected = false;
      }
    });
    setSelectedId(event.itemIndex);
    setExpanded(true);
  };

  const CustomItem = (props: DrawerItemProps) => {
    return (
      <DrawerItem title={expanded ? props.text : ""} {...props} className="scorecards">
        <span
          title={!expanded ? props.text : ""}
          className={"k-icon " + props.icon}
        />
        <span className={"k-item-text"}>{props.text}</span>
      </DrawerItem>
    );
  };

  return (
    <div className='mainDrawerContainer'>
      <Tooltip
        anchorElement={"target"}
        position={expanded ? "top" : "top"}
        parentTitle={true}
      >
        <div className="mainDrawer navPushDown navPush">
          <div className="mainDrawerInner">
            <div className="miniButton">
              <Button
                icon="menu"
                fillMode="flat"
                onClick={handleExpandChange}
              >
                <i className="bi bi-list"></i>
              </Button>
            </div>
            <Drawer
              expanded={expanded}
              position="start"
              mode="push"
              width={230}
              mini={true}
              items={navItems.map((item: INavItem) => {
                return item;
              })}
              onSelect={handleSelectionChange}
              item={CustomItem}
            >
              <DrawerContent>
                <div className="contentPush">
                  {navItems.find((item) => item.selected === true)?.content}
                </div>
              </DrawerContent>
            </Drawer>
          </div>
        </div>
      </Tooltip>
    </div>
  )
}

export default ScorecardManagement